/**
 * Pattern renderer registry. Every pattern type of the catalog maps to a
 * renderer; asking for an unimplemented one throws with a clear message.
 */
import { renderBlog } from './blog.js';
import { renderContact } from './contact.js';
import { renderCta } from './cta.js';
import { renderCustom } from './custom.js';
import { renderFaq } from './faq.js';
import { renderFeaturesGrid } from './features_grid.js';
import { renderFooter } from './footer.js';
import { renderGallery } from './gallery.js';
import { renderHeader } from './header.js';
import { renderHero } from './hero.js';
import { renderHours } from './hours.js';
import { renderLogoCloud } from './logo_cloud.js';
import { renderMenuCard } from './menu_card.js';
import { renderPortfolio } from './portfolio.js';
import { renderPricing } from './pricing.js';
import { renderProcess } from './process.js';
import { renderStatsStrip } from './stats_strip.js';
import { renderTeam } from './team.js';
import { renderTestimonials } from './testimonials.js';
import type { PatternSectionT, PatternTypeT } from '../../schema/index.js';

export type PatternRenderer = (section: PatternSectionT) => string;

const REGISTRY: Partial<Record<PatternTypeT, PatternRenderer>> = {
  blog: renderBlog,
  contact: renderContact,
  cta: renderCta,
  custom: renderCustom,
  faq: renderFaq,
  features_grid: renderFeaturesGrid,
  footer: renderFooter,
  gallery: renderGallery,
  header: renderHeader,
  hero: renderHero,
  hours: renderHours,
  logo_cloud: renderLogoCloud,
  menu_card: renderMenuCard,
  portfolio: renderPortfolio,
  pricing: renderPricing,
  process: renderProcess,
  stats_strip: renderStatsStrip,
  team: renderTeam,
  testimonials: renderTestimonials,
};
// Frozen: the renderer table is fixed first-party code, never mutated at
// runtime (a public mutator would be an arbitrary-HTML injection surface).
Object.freeze(REGISTRY);

export function rendererFor(type: PatternTypeT): PatternRenderer {
  const renderer = REGISTRY[type];
  if (!renderer) {
    const implemented = Object.keys(REGISTRY).sort((left, right) => left.localeCompare(right)).join(', ');
    throw new Error(`no renderer for pattern type "${type}" (implemented: ${implemented})`);
  }
  return renderer;
}

export function implementedPatternTypes(): PatternTypeT[] {
  return Object.keys(REGISTRY).sort((left, right) => left.localeCompare(right)) as PatternTypeT[];
}
